// Core
import React from "react";

// Styles
import "./styles.scss";

const RadioButton = ({ label, value, isSelected, onChange, name }) => {
  return (
    <label className="radio-button">
      <input
        type="radio"
        name={name}
        value={value}
        checked={isSelected}
        onChange={onChange}
      />
      <span className="checkmark"></span>
      {label}
    </label>
  );
};

export default RadioButton;
